import type { HelpFile } from '../../types/help'
import { SeverityBadgeTestIds } from '../../../testids/SeverityBadgeTestIds'

export const severityBadgeHelp: HelpFile = {
  docPage: '/docs/schema/violations',
  texts: {
    [SeverityBadgeTestIds.severityBadgeRow]:
      'Verstoßzusammenfassung pro Entität — zählt offene Verstöße gruppiert nach Schweregrad. Klick auf ein Badge öffnet die Verstoßliste, gefiltert auf diese Entität.',
    [SeverityBadgeTestIds.severityBadgeLink]: 'Zur Verstoßliste navigieren, gefiltert auf die Entität, die dieses Badge trägt.',
    [SeverityBadgeTestIds.severityBadgeCritical]: 'Anzahl offener CRITICAL-Verstöße für diese Entität.',
    [SeverityBadgeTestIds.severityBadgeError]: 'Anzahl offener ERROR-Verstöße für diese Entität.',
    [SeverityBadgeTestIds.severityBadgeWarn]: 'Anzahl offener WARN-Verstöße für diese Entität.',
    [SeverityBadgeTestIds.severityBadgeReferenceBroken]:
      'Mindestens eine Entitätsreferenz auf diesem Verstoß kann nicht mehr aufgelöst werden — meist ein gelöschtes Ziel. Verstoß beheben oder Ziel wiederherstellen.',
    [SeverityBadgeTestIds.severityBadgeZero]: 'Keine offenen Verstöße für diese Entität.',
  },
}
